import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Heroimg2 from '../components/Heroimg2'
import Work from '../components/Work'
import { Helmet } from 'react-helmet-async'
import Slider from '../components/Slider'


function project() {
  return (
    <>
    <Helmet>
      <title>Projects</title>
      <meta name='description' content={"'All my work collected on one place, Explore!.'"}/>
      <link rel='canonical' href='' />
    </Helmet>
    <div>
      <Navbar />
      <Heroimg2 heading="PROJECTS." text="Access my recent projects"/>
      <Work/>
      <Slider/>
      <Footer />
    </div>
    </>
  )
}

export default project